import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/auth/event_bus.js